module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "pagination"
  }, [_c('li', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.params.page !== 1),
      expression: "params.page !== 1"
    }]
  }, [_c('a', {
    attrs: {
      "href": "#"
    },
    domProps: {
      "textContent": _vm._s('<')
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.goPrevious()
      }
    }
  })]), _vm._v(" "), _vm._l((_vm.pages), function(n) {
    return _c('li', {
      class: {
        current: _vm.params.page === n
      }
    }, [_c('router-link', {
      attrs: {
        "to": {
          path: 'articles',
          query: {
            page: n
          }
        }
      }
    }, [_vm._v("\n      " + _vm._s(n) + "\n    ")])], 1)
  }), _vm._v(" "), _c('li', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.params.page !== _vm.pages),
      expression: "params.page !== pages"
    }]
  }, [_c('a', {
    attrs: {
      "href": "#"
    },
    domProps: {
      "textContent": _vm._s('>')
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.goNext()
      }
    }
  })])], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-942b9adc!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/pagination.vue
// module id = 101
// module chunks = 3